import type { FilterSelection } from '@/domain/prices/filters/types';
import defaultFetch from 'isomorphic-unfetch';
import type { TransportSelectorContext, TransportSelectorFilters } from '../types';
import type { TransportSelectorUrlBuilder } from '../urlBuilder/transportSelectorUrlBuilder';
import { TransportType, createTransportSelectorUrlBuilder } from '../urlBuilder/transportSelectorUrlBuilder';
import {
  createSelfDriveSelectorResponseMapper,
  type SelfDriveSelectorResponseMapper,
} from './selfDriveSelectorResponseMapper';
import type { SelfDriveApiRawResponse } from './types';

interface Dependencies {
  fetch: typeof defaultFetch;
  selfDriveSelectorResponseMapper: SelfDriveSelectorResponseMapper;
  transportSelectorUrlBuilder: TransportSelectorUrlBuilder;
}

export const createSelfDriveSelectorApiClient = (dependencies: Partial<Dependencies> = {}) => {
  const {
    fetch = defaultFetch,
    selfDriveSelectorResponseMapper = createSelfDriveSelectorResponseMapper(),
    transportSelectorUrlBuilder = createTransportSelectorUrlBuilder(),
  } = dependencies as Dependencies;

  const fetchOptions: RequestInit = {
    referrerPolicy: 'no-referrer-when-downgrade',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  };

  async function getSelfDrive(
    criteria: TransportSelectorContext & { filterSelection: FilterSelection } & TransportSelectorFilters
  ) {
    const url = transportSelectorUrlBuilder.buildUrl(criteria, TransportType.SelfDrive);

    const response = await fetch(url, fetchOptions);

    const data = (await response.json()) as SelfDriveApiRawResponse;

    return selfDriveSelectorResponseMapper.map(data);
  }

  return { getSelfDrive };
};
